module.exports = __webpack_public_path__ + "img/arrow-up.9d211d49.svg";